import OrganisationsContainer from './OrganisationsContainer';

export default OrganisationsContainer;
